// extracted by css-extract-rspack-plugin
export default {"dialogActions":"yStXqxkcgy41aoQE","dialogBody":"isWqn2_Feng15ivg","editorAvatar":"WjZKgJNYYcYjl9RA","emptyState":"QHEncTEdrYw4pGsq","loading":"w8CQOA4zWrEUh3jX"};